import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpQueueService {
  private queue: string[] = [];
  private currentTask!: string;
  private queueSubject = new BehaviorSubject<string>(undefined);

  /**
   * Check if request already exist in queue.
   * @param name - Name of Request
   * @returns true if request already in queue
   */
  hasRequest(name: string): boolean {
    return this.queue.some((task) => task === name);
  }

  /**
   * Add HTTP request to the queue with error handling
   */
  enqueueRequest(name: string): void {
    this.queue.push(name);

    if (!this.currentTask) {
      this.processNextRequest(); // Start processing
    }
  }

  watch() {
    return this.queueSubject.asObservable();
  }

  /**
   * Process the next request in the queue
   */
  private processNextRequest(): void {
    if (this.queue.length === 0) {
      this.currentTask = null;
      return;
    }

    this.currentTask = this.queue.shift()!;
    this.queueSubject.next(this.currentTask);
  }

  /**
   * Current request mark as completed and pick next request
   */
  requestCompleted() {
    this.currentTask = null;
    this.processNextRequest();
  }

  /**
   * Current request failed so reprocess it again.
   */
  requestFailed() {
    // if error in refreshing, wait then try again
    setTimeout(() => {
      this.queueSubject.next(this.currentTask);
    }, 10000);
  }
}
